// import type { ApiContext } from "shared/api";

export type FirebaseWebConfig = {
  apiKey: string;
  authDomain: string;
  projectId: string;
  messagingSenderId: string;
  appId: string;
  // Firebase Console → Project settings → Cloud Messaging → Web Push certificates
  vapidKey: string;
};

// Конфиг веб-приложения из Firebase Console → Project settings → General → Your apps.
// Значения не секретные. Проект должен совпадать с тем, чей ключ стоит
// на бэкенде этого окружения (FIREBASE_CREDENTIALS).
// null — web push в этом окружении выключен.
// export const firebaseConfigs: Record<ApiContext, FirebaseWebConfig | null> = {
//   stage: {
//     apiKey: "AIzaSyAIkmWa8Y5DDdaUtgQ-BxOS2XR9dOrqx7M",
//     authDomain: "akjet-dev-svs.firebaseapp.com",
//     projectId: "akjet-dev-svs",
//     messagingSenderId: "573857912076",
//     appId: "1:573857912076:web:002eb8e812abdaaf8ca529",
//     vapidKey:
//       "BDPVgCBvmtPb9YtzD3gES1p2PEPLeRB_W17FVimSM9LbB_w2J8b1vLyAm4grCy_BEp8B6j__HuWU3BDGDiwzKyY",
//   },
//   prod: null,
// };
export const firebaseConfig = {
  apiKey: "AIzaSyDZ3mjudRhW23xHdLrtm8gWCXXp77DrWB0",
  authDomain: "akjet-507215.firebaseapp.com",
  projectId: "akjet-507215",
  storageBucket: "akjet-507215.firebasestorage.app",
  messagingSenderId: "272985228004",
  appId: "1:272985228004:web:a207ff106ab205c88662f1",
  vapidKey:
    "BBvf4trwKQIcNTdyEA83X8bUYyNOQMePaTWAt0SCMnDd_xtxY_tqc_XO8izoptvx0Nr2nfqB8yTyGa1cnlG391k",
};
